// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"yb_a big_a big_x","StrollerDetailRating__muted":"yb_b big_fo"};